import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FIELDS = [
  ['name', 'Nombre completo'], ['address', 'Dirección'], ['postal_code', 'Código postal'], ['city', 'Ciudad'],
  ['province', 'Provincia'], ['country', 'País'], ['phone', 'Teléfono'], ['email', 'Correo electrónico'],
];

const initial = (order) => {
  const a = order.shipping_address || {};
  return Object.fromEntries(FIELDS.map(([k]) => [k, (k === 'name' ? a.full_name || a.name : a[k]) || '']));
};

export const EditAddressDialog = ({ order, open, onOpenChange, onSaved, toast }) => {
  const [form, setForm] = useState(() => initial(order));
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await axios.patch(`${API}/orders/${order.id}/address`, form);
      toast({ title: 'Dirección guardada', description: 'La etiqueta ya saldrá con los datos nuevos.' });
      onOpenChange(false);
      onSaved();
    } catch (e) {
      toast({ title: 'Error', description: 'No se pudo guardar la dirección', variant: 'destructive' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="edit-address-dialog">
        <DialogHeader>
          <DialogTitle>Editar envío · {order.order_number}</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {FIELDS.map(([k, label]) => (
            <div key={k} className={k === 'name' || k === 'address' || k === 'email' ? 'col-span-2' : ''}>
              <Label className="text-xs">{label}</Label>
              <Input
                value={form[k]}
                onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                data-testid={`edit-address-${k}`}
              />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="edit-address-cancel">Cancelar</Button>
          <Button onClick={save} disabled={saving} className="bg-black text-white" data-testid="edit-address-save">
            {saving ? 'Guardando…' : 'Guardar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
